import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Button, IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ReactTable from "react-table";
import * as moment from 'moment';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    button: {
        width: '100%'
    }
});

class NotificationAuthList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const rows = this.props.AuthList

        return (
            <ReactTable
                columns={[
                    {
                        Header: "FullName",
                        accessor: "FullName",
                    },
                    {
                        Header: "Viewed",
                        id: "Viewed",
                        accessor: a => a.Viewed === 1 ? moment(a.ViewDate).format('YYYY-MM-DD h:mm A') : ''
                        // accessor: a => a.Viewed === 1 ? 'Yes' : 'No'
                    },
                    {
                        Header: "Resolved",
                        id: "Resolved",
                        accessor: a => a.Resolved === 1 ? 'Yes' : 'No'
                    }

                ]}
                data={rows}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="No Notifications Found"
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationAuthList)));




// WEBPACK FOOTER //
// src/main/content/notification/NotificationAuthList.js